import { render, staticRenderFns } from "./AsAMasterPageMenu.vue?vue&type=template&id=0072c112&scoped=true"
import script from "./AsAMasterPageMenu.vue?vue&type=script&lang=js"
export * from "./AsAMasterPageMenu.vue?vue&type=script&lang=js"
import style0 from "./AsAMasterPageMenu.vue?vue&type=style&index=0&id=0072c112&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0072c112",
  null
  
)

export default component.exports